import React, { useState } from "react";
import { useGame } from "../../contexts/GameContext";
import { CLASSES, STAT_NAMES_FULL, STAT_LABELS } from "../../data/classes";
import { ELEMENTS } from "../../utils/gameLogic";
import { StatsGrid } from "./StatsDisplay";
import { X, Sparkles } from "lucide-react";

export const CharacterPanel = ({ open, onClose }) => {
  const { character } = useGame();
  if (!open || !character) return null;
  const classe = CLASSES[character.classeId];
  return (
    <div
      data-testid="character-panel"
      className="fixed inset-0 z-50 bg-slate-950/80 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-slate-800 border-4 border-slate-950 rounded-3xl p-6 max-w-2xl w-full cartoon-shadow-lg-static max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start gap-4 mb-4">
          <div className={`w-24 h-24 rounded-2xl bg-gradient-to-br ${classe.couleur} border-4 border-slate-950 overflow-hidden flex-shrink-0 cartoon-shadow-static`}>
            <img src={classe.image} alt={classe.nom} className="w-full h-full object-cover" />
          </div>
          <div className="flex-1">
            <h2 className="font-display text-2xl font-bold text-slate-50">{classe.nom}</h2>
            {classe.element && (
              <span className={`inline-block ${ELEMENTS[classe.element].couleur} ${ELEMENTS[classe.element].textColor} border-2 border-slate-950 rounded-md px-2 py-0.5 text-xs font-bold mt-1`}>
                {ELEMENTS[classe.element].icon} {ELEMENTS[classe.element].nom}
              </span>
            )}
            <p className="text-sm text-slate-300 mt-1">{classe.description}</p>
          </div>
          <button data-testid="character-panel-close" onClick={onClose} className="bg-rose-500 text-white border-4 border-slate-950 rounded-xl w-10 h-10 flex items-center justify-center cartoon-shadow">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="mb-4">
          <h3 className="font-display text-sm uppercase tracking-wider text-slate-400 mb-2">Statistiques</h3>
          <StatsGrid stats={character.stats} />
        </div>

        <div className="mb-4 bg-slate-900 border-2 border-slate-700 rounded-2xl p-4">
          <h3 className="font-display text-sm uppercase tracking-wider text-yellow-400 mb-2">Compétences</h3>
          <div className="space-y-2">
            {classe.competences.map((c) => (
              <div key={c.id} className="flex items-start gap-2 text-sm">
                <span className="text-lg">{c.icon}</span>
                <div className="flex-1">
                  <p className="font-bold text-slate-100">{c.nom} <span className="text-xs text-sky-400">({c.cout === 0 ? "Gratuit" : `${c.cout}⚡`})</span></p>
                  <p className="text-xs text-slate-400">{c.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="font-display text-sm uppercase tracking-wider text-fuchsia-400 mb-2 flex items-center gap-2">
            <Sparkles className="w-4 h-4" /> Passifs accumulés ({character.passifs?.length || 0})
          </h3>
          {(character.passifs || []).length === 0 ? (
            <p className="text-slate-500 text-sm italic">Aucun passif pour le moment. Visitez les sanctuaires !</p>
          ) : (
            <div className="space-y-1.5 max-h-48 overflow-y-auto pr-2">
              {character.passifs.map((p, i) => (
                <div key={p.uuid || i} data-testid={`passif-item-${i}`} className="flex items-center gap-2 bg-slate-900 border-2 border-slate-700 rounded-lg px-3 py-2">
                  <span className="text-lg">{p.icon}</span>
                  <span className="text-xs font-bold uppercase tracking-wider text-fuchsia-300">{p.rarity}</span>
                  <span className="text-sm text-slate-200 flex-1">{p.description}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
